import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';

const styles = theme => ({
  eventCard: {
    color: theme.palette.text.primary,
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.background.border}`,
    borderRadius: 4,
    fontSize: 15,
    marginBottom: 16,
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    padding: 20,
  },
  moveUp: {
    position: 'relative',
    top: -1,
  },
  top: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 15,
    justifyContent: 'space-between',
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
  },
  topHeader: {
    paddingTop: 13,
  },
  grey: {
    color: theme.palette.text.secondary,
    fontSize: 13,
    paddingTop: 5,
    fontWeight: 400,
  },
  biggerFont: {
    fontSize: '18px !important',
    "@media (max-width: 420px)": {
      fontSize: 15,
    },
  },
  label: {
    whiteSpace: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: 14,
    fontWeight: 400,
  },
  bottom: {
    display: 'flex',
    alignItems: 'center',
  },
  bottomDataContainer: {
    display: 'flex',
    maxWidth: '65%',
    flexGrow: 1,
  },
  bottomData: {
    flexGrow: 1,
  },
  focused: {
    borderColor: theme.palette.blue.lightblue,
    borderWidth: 2,
  },
  unincluded: {
    borderColor: theme.palette.background.border,
    background: theme.palette.grey[50],
    color: theme.palette.grey[500],
  },
});

class EventCard extends Component {
  state = {
  };

  onSelectEvent = () => {
    const {
      onSelectEvent,
      event,
    } = this.props;

    onSelectEvent && onSelectEvent(event);
  };

  render() {
    const {
      classes,
      event,
      isFocused,
      location = {},
    } = this.props;

    const startTime = DateTime.fromISO(event.startTime);
    const endTime = event.endTime ? DateTime.fromISO(event.endTime) : null;
    const totalValue = event.value ? event.value / 100 : 0;
    const itemCount = event.items || 0;
    const locationName = event.venue ? event.venue.name : location.name || 'No location';

    return (
      <div
        className={classNames(classes.eventCard,
          isFocused && classes.focused,
          event.isIncludedInBookingTotal === false && classes.unincluded)}
        onClick={this.onSelectEvent}
      >
        <div className={classNames(classes.content, isFocused && classes.moveUp)}>
          <div className={classes.top}>
            <div className={classes.flex}>
              <div className={classNames(classes.biggerFont, classes.label)}>{event.name || event.description}</div>
              <div className={classNames(classes.biggerFont, classes.label)}>{locationName}</div>
            </div>
            {/* <div className={classNames(classes.flex, classes.biggerFont)}>
              <span className={classes.label}>{locationName}</span>
              <span className={classes.label}>{event.estimatedGuestCount} Guests</span>
            </div> */}
          </div>
          <div className={classes.bottom}>
            <div className={classes.flex}>
              <div className={classes.bottomDataContainer}>
                <div className={classes.bottomData}>
                  <div className={classes.label}>Date</div>
                  <div className={classes.grey}>{startTime.toFormat('M/d/yyyy')}</div>
                </div>
                <div className={classes.bottomData}>
                  <div className={classes.label}>Time</div>
                  <div className={classes.grey}>{startTime.toFormat('h:mma')} {endTime ? ` - ${endTime.toFormat('h:mma')}` : ''}</div>
                </div>
                <div className={classes.bottomData}>
                  <div className={classes.label}>Value</div>
                  <div className={classes.grey}>${totalValue}</div>
                </div>
                <div className={classes.bottomData}>
                  <div className={classes.label}>Items</div>
                  <div className={classes.grey}>{itemCount}</div>
                </div>
              </div>
              <div>
                <div className={classNames(classes.biggerFont, classes.label)}>{event.estimatedGuestCount} Guests</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

EventCard.propTypes = {
  isFocused: PropTypes.bool.isRequired,
  onSelectEvent: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired,
  menu: PropTypes.array,
};

export default withStyles(styles)(EventCard);
